import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./Redux/Store/store";
import "react-toastify/dist/ReactToastify.css";

// Sentry Integration - Initialize before any other code
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN, // Set this in your .env file

  integrations: [
    // Automatically capture console logs (warn, error only - no sensitive data)
    Sentry.captureConsoleIntegration({
      levels: ['error'] // Only warnings and errors, no sensitive logs
    }),

    // Browser tracing for performance monitoring
    Sentry.browserTracingIntegration(),

    // Session replay (only in production to avoid performance impact)
    ...(process.env.NODE_ENV === 'production' ? [
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      })
    ] : []),
  ],

  // Performance monitoring (only in production)
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 0,

  // Session replay settings (only in production)
  replaysSessionSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 0,
  replaysOnErrorSampleRate: process.env.NODE_ENV === 'production' ? 1.0 : 0,

  // Environment and release tracking
  environment: process.env.NODE_ENV || "development",
  release: process.env.REACT_APP_VERSION || "1.0.0",

  // Error filtering (optional)
  beforeSend(event, hint) {
    // Filter out development errors if needed
    if (process.env.NODE_ENV === "development") {
      // You can add custom filtering logic here
     // console.log("Sentry Error:", event);
    }
    return event;
  },

  // Before breadcrumb logging
  beforeBreadcrumb(breadcrumb, hint) {
    // Allow seed-related breadcrumbs (they don't contain actual data)
    if (breadcrumb.category === 'seed') {
      return breadcrumb;
    }

    // Filter out sensitive console logs but allow warnings and errors
    if (breadcrumb.category === 'console') {
      // Block any logs that might contain sensitive seed data
      if (breadcrumb.message && (
        breadcrumb.message.includes('seed') ||
        breadcrumb.message.includes('Seed') ||
        breadcrumb.message.includes('SEED') ||
        breadcrumb.message.includes('confidential') ||
        breadcrumb.message.includes('sensitive')
      )) {
        return null; // Don't capture sensitive data
      }

      // Allow warnings and errors
      if (breadcrumb.level === 'warn' || breadcrumb.level === 'error') {
        return breadcrumb;
      }

      // Block regular console.log statements to avoid spam
      return null;
    }

    return breadcrumb;
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Sentry.ErrorBoundary
    fallback={({ error, componentStack, resetError }) => (
      <div style={{
        padding: '20px',
        margin: '20px',
        border: '1px solid #ff6b6b',
        borderRadius: '8px',
        backgroundColor: '#ffeaea'
      }}>
        <h2 style={{ color: '#d63031' }}>Oops! Something went wrong</h2>
        <p style={{ color: '#636e72' }}>
          We've been notified of this error and are working to fix it.
        </p>
        <details style={{ marginTop: '10px' }}>
          <summary style={{ cursor: 'pointer', color: '#0984e3' }}>
            Error Details (for developers)
          </summary>
          <pre style={{
            backgroundColor: '#f8f9fa',
            padding: '10px',
            borderRadius: '4px',
            marginTop: '10px',
            fontSize: '12px',
            overflow: 'auto'
          }}>
            {error.toString()}
            {componentStack}
          </pre>
        </details>
        <button
          onClick={() => resetError()}
          style={{
            marginTop: '15px',
            padding: '8px 16px',
            backgroundColor: '#0984e3',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Try Again
        </button>
      </div>
    )}
  >
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </Sentry.ErrorBoundary>
);



